import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {STEPS} from "./steps/registry";
import {connect} from "react-redux";
import {setWizardConflictPopupOpened} from "../../../actions/wizardFunctions";
import {enableSquareFootage} from "../../../actions/sqftFunctions";
import {setSQFTPopup} from "../../../actions/sqftMenuFunctions";
import {useChangeWizardStepRoute} from "../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {
  handleOpenModalFix, restoreFromSnapshot,
} from "../../sqft/components/popup/modalFix/CompatibilityWarnings/modalFixHelper";

const WizardConflictPopupSQFTButtons = (props) => {
  const { hideOverlay, setWizardConflictPopupOpened, step, setStep, isSquareFootageEnabled, sqftModalFixState, intl,
    categorizedConflictingCartItems } = props
  const { changeWizardStepRoute } = useChangeWizardStepRoute();

  const { itemsToRemove, itemsToUpdate } = categorizedConflictingCartItems;

  const allItems = [...itemsToRemove, ...itemsToUpdate];

  const withoutSQFT = allItems.every(item => item.cartItem && !item.cartItem.sqftId);
  const removeOnly = !itemsToUpdate.length && itemsToRemove.length;
  const removeAndClose = removeOnly && withoutSQFT;

  const BUTTONS_IN_SQFT = {
    [STEPS.REVIEW]: {
      secondary: {
        id: "confirmPopup.cancel",
        className: "ui-button2 ui-button2--blue",
        // Close overlay and then finalize popup close
        onClick: (hideOverlay) => hideOverlay?.(async() => {
          setWizardConflictPopupOpened(false);
          setStep(STEPS.REVIEW);
          await restoreFromSnapshot(sqftModalFixState.snapshot);
        }),
      },
      primary: {
        id: removeAndClose ? "confirmPopup.applyAndContinue" : "confirmPopup.editItems",
        className: "ui-button2 ui-button2--green ui-button2--with-padding",
        onClick: async (hide) => {
          // await dispatch(applyConflictResolutions());
          hide?.(() => {
            setWizardConflictPopupOpened(false);
            setStep(STEPS.REVIEW);
            handleOpenModalFix({changeWizardStepRoute, intl});
          });
        },
      },
    }
  }
  const BUTTONS_IN_VISUALIZER = {
    [STEPS.REVIEW]: {
      secondary: {
        id: "confirmPopup.cancel",
        className: "ui-button2 ui-button2--blue",
        // Close overlay and then finalize popup close
        onClick: (hideOverlay) => hideOverlay?.(async () => {
          setWizardConflictPopupOpened(false);
          setStep(STEPS.REVIEW);
          await restoreFromSnapshot(sqftModalFixState.snapshot);
        }),
      },
      primary: {
        id: removeAndClose ? "confirmPopup.applyAndContinue" : "confirmPopup.editItems",
        className: "ui-button2 ui-button2--green ui-button2--with-padding",
        onClick: (hide) => {
          if (removeOnly || withoutSQFT) {
            hide?.(() => {
              handleOpenModalFix({changeWizardStepRoute, intl});
              setWizardConflictPopupOpened(false);
            });
          } else {
            setStep(STEPS.FIX)
          }
        },
      },
    },
    [STEPS.FIX]: {
      secondary: {
        id: "confirmPopup.cancel",
        className: "ui-button2 ui-button2--blue",
        onClick: () => setStep(STEPS.REVIEW),
      },
      primary: {
        id: "confirmPopup.applyAndContinue",
        className: "ui-button2 ui-button2--green",
        onClick: async (hide) => {
          // await dispatch(applyConflictResolutions());
          hide?.(() => {
            setWizardConflictPopupOpened(false);
            setStep(STEPS.REVIEW);
            handleOpenModalFix({changeWizardStepRoute, intl});
          });
        },
      },
    },
  };

  const { secondary, primary } = isSquareFootageEnabled ? BUTTONS_IN_SQFT[step] : BUTTONS_IN_VISUALIZER[step];

  const renderBtn = (btn) => {
    if (!btn) return null;
    const handleClick = () => btn.onClick?.(hideOverlay);
    return (
      <button
        type="button"
        className={btn.className || "btn conflict-popup__btn"}
        onClick={handleClick}
      >
        <FormattedMessage id={btn.id} />
      </button>
    );
  };

  return (
    <div className="ui-popup__footer conflict-popup__footer">
      {renderBtn(secondary)}
      {renderBtn(primary)}
    </div>
  );
};

const mapStateToProps = (store) => ({
  isSquareFootageEnabled: store.sqftState.isSquareFootageEnabled,
  sqftModalFixState: store.sqftModalFixState,
});

const mapDispatchToProps = {
  setWizardConflictPopupOpened,
  enableSquareFootage,
  setSQFTPopup,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardConflictPopupSQFTButtons)
);

